import React from "react";
/**
 * QV Video Player.
 * Embed responsive para vídeos de ejercicios. Fallback seguro a link externo.
 *
 * Formatos soportados:
 *  - YouTube: youtu.be/, youtube.com/watch?v=, youtube.com/embed/, youtube.com/shorts/
 *  - Vimeo: vimeo.com/{id}
 *  - Fallback: cualquier otra URL abre en pestaña nueva
 */

function extractYouTubeId(url) {
  if (!url) return null;
  const patterns = [
    /(?:youtube\.com\/watch\?[^#]*v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/shorts\/|youtube\.com\/live\/)([\w-]{6,15})/i,
  ];
  for (const p of patterns) {
    const m = url.match(p);
    if (m) return m[1];
  }
  return null;
}

function extractVimeoId(url) {
  const m = url && url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  return m ? m[1] : null;
}

export function getEmbedInfo(url) {
  if (!url) return { kind: "none" };
  const yt = extractYouTubeId(url);
  if (yt) return { kind: "youtube", src: `https://www.youtube-nocookie.com/embed/${yt}?rel=0&modestbranding=1&playsinline=1` };
  const vm = extractVimeoId(url);
  if (vm) return { kind: "vimeo", src: `https://player.vimeo.com/video/${vm}?dnt=1&byline=0&portrait=0&title=0` };
  return { kind: "external", src: url };
}

export function VideoPlayer({ url, title = "Vídeo del ejercicio", compact = false }) {
  const info = getEmbedInfo(url);
  if (info.kind === "none") return null;
  if (info.kind === "external") {
    return (
      <a href={info.src} target="_blank" rel="noopener noreferrer"
         data-testid="video-external-link"
         style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 12, color: "#dc2626", textDecoration: "none", padding: "4px 0" }}>
        ▷ Ver vídeo (abre externo)
      </a>
    );
  }
  return (
    <div className="qv-video-wrap" data-testid={`video-embed-${info.kind}`} style={{ position: "relative", paddingBottom: compact ? "56.25%" : "56.25%", height: 0, overflow: "hidden", background: "#000", borderRadius: 3, marginTop: 4 }}>
      <iframe
        src={info.src}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        loading="lazy"
        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", border: 0 }}
      />
    </div>
  );
}

export default VideoPlayer;
